import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';

export type BriefGenerationPollingResponse = string;

export const generateBriefUrl = pathfinder('generate_ai_brief');

interface GenerateBriefParams {
    userInput: string;
    subcategoryId?: number;
    contextId: string;
    source?: string;
    briefType?: 'dynamic_matching' | 'dynamic_matching_person';
}

export const generateBrief = async ({ userInput, subcategoryId, contextId, source, briefType }: GenerateBriefParams) =>
    axios.post<BriefGenerationPollingResponse>(generateBriefUrl, {
        user_input: userInput,
        subcategory_id: subcategoryId || null,
        source,
        brief_type: briefType || 'dynamic_matching',
        context_id: contextId,
    });
